import React, { useEffect } from 'react';
import CustomError from '@components/CustomError';
import { NextPage, NextPageContext } from 'next';
import Main from '@components/Layout/Main';
import { NeedHelpSection } from '@components/NeedHelpSection';
import { useTranslations } from '@hooks/useTranslations';
import { useGTM } from '@hooks/useGTM';
import FAQs from '@components/FAQs';
import routes from '../constants/routes';
import { useJourneyType } from '@hooks/useJourneyType';

export enum ERROR_CODE {
    NOT_FOUND = 404,
}

interface Props {
    statusCode: number;
    namespacesRequired: string[];
}

const ErrorPage: NextPage<Props> = ({ statusCode }) => {
    const { t } = useTranslations();
    const { paymentJourneyType } = useJourneyType();
    const { pushErrorPageLoad } = useGTM();
    useEffect(() => {
        pushErrorPageLoad(statusCode, paymentJourneyType);
    }, []);

    return (
        <Main>
            <CustomError
                errorType={String(statusCode)}
                returnLink={routes.ROOT}
                returnLinkLabel={t('errorPage.returnLink.label')}
                titleDescription={t('errorPage.notFound.description')}
            />

            <NeedHelpSection />
            <FAQs />
        </Main>
    );
};

// Todo log the error !!!
// Todo default error page should has error code 500
ErrorPage.getInitialProps = ({ res, err }: NextPageContext): Props => {
    return {
        statusCode: res?.statusCode || err?.statusCode || ERROR_CODE.NOT_FOUND,
        namespacesRequired: ['common'],
    };
};

export default ErrorPage;
